"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userRecipe = exports.sidenavRecipe = exports.shellRecipe = exports.settingsRecipe = exports.sessionRecipe = exports.pulseRecipe = exports.permissionsRecipe = exports.capabilityRecipe = exports.appRecipe = void 0;

var _SettingsLevel = require("@adobe/exc-app/settings/SettingsLevel");

// App API recipe
const appRecipe = {
  methods: ['get'],
  name: 'app'
}; // Capability API recipe

exports.appRecipe = appRecipe;
const capabilityRecipe = {
  methods: ['get'],
  name: 'capability'
}; // Permissions API recipe

exports.capabilityRecipe = capabilityRecipe;
const permissionsRecipe = {
  methods: ['get'],
  name: 'permissions'
}; // Pulse API recipe

exports.permissionsRecipe = permissionsRecipe;
const pulseRecipe = {
  methods: ['send'],
  name: 'pulse'
}; // Session API recipe

exports.pulseRecipe = pulseRecipe;
const sessionRecipe = {
  methods: ['get', 'invalidate', 'set'],
  name: 'session'
}; // Settings API recipe

exports.sessionRecipe = sessionRecipe;
const settingsRecipe = {
  base: {
    SETTINGS_LEVEL: _SettingsLevel.SettingsLevel
  },
  methods: ['get', 'set'],
  name: 'settings'
}; // Shell API recipe

exports.settingsRecipe = settingsRecipe;
const shellRecipe = {
  methods: ['emit', 'get', 'off', 'on'],
  name: 'shell'
}; // User API recipe

exports.shellRecipe = shellRecipe;
const userRecipe = {
  methods: ['authExpired', 'emit', 'get', 'getCustomToken', 'off', 'on'],
  name: 'user',
  properties: ['logoutUrl', 'showLanguagePicker']
}; // Sidenav API recipe

exports.userRecipe = userRecipe;
const sidenavRecipe = {
  methods: ['emit', 'get', 'off', 'on'],
  name: 'sidenav',
  properties: ['sidenav/visible', 'sidenav/collapsed', 'sidenav/config']
};
exports.sidenavRecipe = sidenavRecipe;